import { useState, useEffect } from "react";
import axios, { API } from "../../api";
import { StoryCard } from "./StoryCard";

export function StoriesFeedModal({ onClose }) {
  const [feed, setFeed] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState('loved');
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    loadFeed();
  }, [sortBy, filter]);

  const loadFeed = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ sort: sortBy, limit: 30 });
      if (filter !== 'all') params.append('content_type', filter);
      const response = await axios.get(`${API}/stories/feed?${params}`);
      setFeed(response.data.feed || []);
    } catch (error) {
      console.error("Feed error:", error);
    } finally {
      setLoading(false);
    }
  };

  const react = async (story, mood) => {
    try {
      const reactionToSend = story.user_reaction === mood ? 'remove' : mood;
      await axios.post(`${API}/stories/react`, {
        content_type: story.content_type,
        content_id: story.id,
        reaction: reactionToSend
      });
      setFeed(prev => prev.map(s => {
        if (s.id === story.id && s.content_type === story.content_type) {
          const newReactions = { ...s.reactions };
          if (s.user_reaction) {
            newReactions[s.user_reaction] = Math.max(0, (newReactions[s.user_reaction] || 1) - 1);
            if (newReactions[s.user_reaction] === 0) delete newReactions[s.user_reaction];
          }
          if (reactionToSend !== 'remove') {
            newReactions[mood] = (newReactions[mood] || 0) + 1;
          }
          return {
            ...s,
            user_reaction: reactionToSend === 'remove' ? null : mood,
            reactions: newReactions,
            total_loves: Object.values(newReactions).reduce((a, b) => a + b, 0)
          };
        }
        return s;
      }));
    } catch (error) {
      console.error("React error:", error);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="stories-modal" onClick={(e) => e.stopPropagation()}>
        <div className="journal-header">
          <h2>🌍 Aura Stories</h2>
          <button className="journal-close" onClick={onClose} data-testid="stories-close-btn">×</button>
        </div>
        <p className="journal-subtitle">Discover Auras from around the world</p>

        <div className="stories-filters">
          <div className="filter-group">
            <button
              className={`filter-pill ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
              data-testid="filter-all"
            >All</button>
            <button
              className={`filter-pill ${filter === 'wallpaper' ? 'active' : ''}`}
              onClick={() => setFilter('wallpaper')}
              data-testid="filter-wallpaper"
            >🎨 Wallpapers</button>
            <button
              className={`filter-pill ${filter === 'memory' ? 'active' : ''}`}
              onClick={() => setFilter('memory')}
              data-testid="filter-memory"
            >💫 Memories</button>
            <button
              className={`filter-pill ${filter === 'letter' ? 'active' : ''}`}
              onClick={() => setFilter('letter')}
              data-testid="filter-letter"
            >💌 Letters</button>
          </div>
          <div className="sort-group">
            <button
              className={`filter-pill small ${sortBy === 'loved' ? 'active' : ''}`}
              onClick={() => setSortBy('loved')}
              data-testid="sort-loved"
            >✨ Loved</button>
            <button
              className={`filter-pill small ${sortBy === 'recent' ? 'active' : ''}`}
              onClick={() => setSortBy('recent')}
              data-testid="sort-recent"
            >🕐 Recent</button>
          </div>
        </div>

        {loading ? (
          <div className="journal-loading">Loading stories...</div>
        ) : feed.length === 0 ? (
          <div className="journal-empty">
            <p>🌸</p>
            <p>No stories yet. Be the first to share your Aura!</p>
          </div>
        ) : (
          <div className="stories-feed">
            {feed.map((story) => (
              <StoryCard
                key={`${story.content_type}-${story.id}`}
                story={story}
                onReact={react}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
